import Sortable from 'sortablejs';
import toastr from 'toastr';

toastr.options = {
  positionClass: 'toast-bottom-left',
};

let el = document.querySelector('.module--favorites__items--items');

if (el && window.innerWidth > 768) {
  Sortable.create(el, {
    animation: 150,
    handle:
      window.innerWidth < 1500
        ? '.module--favorites__items__row__handle'
        : null, // Use handle under 1500px
    onUpdate: function () {
      let productIds = [];
      document
        .querySelectorAll('.module--favorites__items__row--item')
        .forEach((row, index) => {
          let productId = $(row).data('product'); // Je moet de product_id als een data-attribuut toevoegen aan elke rij
          productIds.push({ uuid: productId, sort_order: index + 1 });
        });

      $.ajax({
        url: $(el).data('ajax'),
        method: 'POST',
        data: {
          action: 'favorites_sort',
          product_ids: JSON.stringify(productIds),
        },
        success: function () {
          toastr.options.closeDuration = 100;
          toastr.success('De volgorde is opgeslagen.');
        },
        error: function (error) {
          toastr.error(
            'Er is iets fout gegaan met het opslaan van je volgorde.'
          );
          console.log(error);
        },
      });
    },
  });
}

$(document).on('click', '.delete-favorite', function (e) {
  e.preventDefault();

  const isconfirmed = confirm(
    'Weet je zeker dat je dit product wilt verwijderen uit je favorieten?'
  );

  if (!isconfirmed) {
    return;
  }

  const ajaxUrl = $('.module--favorites__items--items').data('ajax');
  const productId = $(this).data('product');

  $.ajax({
    type: 'POST',
    url: ajaxUrl,
    data: {
      action: 'delete_favorite_in_list',
      product_id: productId,
    },
    success: function (response) {
      $('.module--favorites__items--items').empty();
      $('.module--favorites__items--items').html(response);

      toastr.success('Product is verwijdert als favoriet');
    },
    error: function (error) {
      toastr.error('Er is een fout opgetreden. Probeer het later opnieuw.');
      console.error(error);
    },
  });
});

// sometimes there may be favorites, but the product no longer exists. The list is then displayed, but without items.
// the list will not be displayed via the check below.
if ($('.module--favorites__items__row').length > 1) {
  $('.module--favorites__items').css('opacity', '1');
} else {
  $('.module--favorites__items__empty').removeClass('d-none');
}

function getCartTotal() {
  $.ajax({
    url: cart_object.ajax_url, // eslint-disable-line
    type: 'POST',
    data: {
      action: 'get_cart_total',
    },
    success: function (response) {
      if ($('.cart-total').length) {
        $(
          '.top-bar .btn--cart a .cart-total, .collapse__wrapper .btn--cart .cart-total'
        ).text(response);
      } else {
        $('.top-bar .btn--cart a, .collapse__wrapper .btn--cart').prepend(
          '<span class="cart-total">' + response + '</span>'
        );
      }
    },
  });
}
$(document).ready(function () {
  function updateOrderAllButtons() {
    let totalItems = 0;
    let uniqueProductIds = new Set();

    $('.product__quantity--favorite, .quantity_kilo_row').each(function () {
      let productId = $(this).data('product');
      let quantity = parseInt($(this).val()) || 0; // Default to 0 if NaN

      if (!productId) {
        console.warn('⚠ Skipping an entry with no product ID!', this);
        return; // Skip this iteration if no product ID
      }

      if (quantity > 0) {
        if (!uniqueProductIds.has(productId)) {
          uniqueProductIds.add(productId);
          totalItems++;
        }
      }
    });

    // Update all "order all" buttons
    $('.order-all-favorites').each(function () {
      $(this).text(`Bestel ${totalItems} artikelen`);
      $(this).prop('disabled', totalItems === 0);
    });
  }

  // Ensure hidden input updates when the kg input changes
  $(document).on('input', '.quantity_kilo', function () {
    let kgInput = $(this);
    let productId = kgInput.data('product');
    let kiloValue = parseFloat(kgInput.val()) || 0;
    let gramValue = Math.round(kiloValue * 1000); // Convert kg to grams

    let hiddenInput = $(`#quantity_${productId}`);
    hiddenInput.val(gramValue).trigger('input'); // Update hidden input and trigger event

    updateOrderAllButtons(); // Ensure order button updates
  });

  // Ensure normal quantity inputs also trigger updateOrderAllButtons
  $(document)
    .off('input', '.product__quantity--favorite, .quantity_kilo_row')
    .on(
      'input',
      '.product__quantity--favorite, .quantity_kilo_row',
      function () {
        updateOrderAllButtons();
      }
    );

  $(document)
    .off('click keypress', '[data-plus-one], [data-minus-one]')
    .on(
      'click keypress',
      '[data-plus-one], [data-minus-one]',
      function (event) {
        if (
          event.type === 'click' ||
          (event.type === 'keypress' &&
            (event.key === 'Enter' || event.keyCode === 13))
        ) {
          setTimeout(updateOrderAllButtons, 100);
        }
      }
    );

  // Bulk Order Button Click
  $(document)
    .off('click', '.order-all-favorites')
    .on('click', '.order-all-favorites', function () {
      let items = [];
      const ajaxUrl = $('.module--favorites__items--items').data('ajax');

      $('.product__quantity--favorite, .quantity_kilo_row').each(function () {
        let productId = $(this).data('product');
        let quantity = parseInt($(this).val()) || 0; // Ensure it's always a number

        if (!productId) {
          console.warn('⚠ Skipping an entry with no product ID!', this);
          return; // Skip this iteration
        }

        if (quantity > 0) {
          let existingIndex = items.findIndex(
            (item) => item.product_id === productId
          );

          if (existingIndex === -1) {
            items.push({ product_id: productId, quantity: quantity });
          }
        }
      });

      if (items.length > 0) {
        $.ajax({
          url: ajaxUrl,
          method: 'POST',
          data: {
            action: 'bulk_add_to_cart',
            items: JSON.stringify(items),
          },
          success: function () {
            toastr.success('Producten zijn toegevoegd aan winkelmand');
            getCartTotal();
          },
          error: function (xhr, status, error) {
            console.error('❌ AJAX error:', error);
            console.error(
              '❌ XHR response:',
              xhr.responseText || 'No response received'
            );
            console.error('❌ Status:', status);
            toastr.error(
              'Er is een fout opgetreden. Probeer het later opnieuw.'
            );
          },
        }).fail(function (xhr, status, error) {
          console.error('🚨 AJAX Fail Handler:', error, xhr.responseText);
        });
      } else {
        toastr.warning('⚠ Geen producten geselecteerd.');
      }
    });

  updateOrderAllButtons(); // Initialize button state on page load
});
